import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

export default function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let scroller;
    const configure = () => {
      scroller?.destroy();
      scroller = undefined;
      if (!preference.matches) {
        scroller = new Lenis({
          autoRaf: true,
          lerp: 0.09,
          smoothWheel: true,
          syncTouch: false,
          allowNestedScroll: true,
          anchors: { offset: -80 },
        });
      }
    };
    configure();
    preference.addEventListener('change', configure);
    return () => {
      preference.removeEventListener('change', configure);
      scroller?.destroy();
    };
  }, [pathname]);

  return null;
}
